import { getParser } from 'bowser';
const browser = getParser(window.navigator.userAgent);
export const getUserAgent = () => {
    return window.navigator.userAgent;
};
// iOSアプリのwebviewのユーザーエージェント
export const isiOSApp = () => {
    const userAgent = getUserAgent().toLowerCase();
    return userAgent.indexOf('lbiosapp') != -1;
};
// iOSアプリのwebブラウザの判定
export const isiOSWeb = () => {
    const userAgent = getUserAgent().toLowerCase();
    return userAgent.indexOf('lbiosapp') == -1 && userAgent.match(/iphone/);
};
// Androidアプリのwebviewのユーザーエージェント
export const isAndroidApp = () => {
    const userAgent = getUserAgent().toLowerCase();
    return userAgent.indexOf('lbandroidapp') != -1;
};
// Androidアプリのwebブラウザの判定
export const isAndroidWeb = () => {
    const userAgent = getUserAgent().toLocaleLowerCase();
    return userAgent.indexOf('lbandroidapp') == -1 && userAgent.match(/android/);
};
// iOS/Androidアプリのwebviewの判定
export const isNativeApp = () => {
    return isAndroidApp() || isiOSApp();
};
// iOS/Androidアプリのブラウザの判定
export const isNativeWeb = () => {
    return isAndroidWeb() || isiOSWeb();
};
export const isMobileSafari = () => {
    return browser.satisfies({
        mobile: {
            safari: '>=9',
        },
    });
};
